import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { frontendErrorReference, reportFrontendError } from "../lib/client-errors";
import { Button } from "./ui";

interface State {
  failed: boolean;
  reference?: string;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true, reference: frontendErrorReference() };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportFrontendError({ error, componentStack: info.componentStack }, this.state.reference!);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error" role="alert">
        <AlertTriangle size={30} />
        <h1>Esta área encontrou um problema.</h1>
        <p>Tente carregar a tela novamente. Seus dados preenchidos não foram enviados.</p>
        <Button type="button" onClick={() => window.location.reload()}>
          <RotateCcw size={17} /> Tentar novamente
        </Button>
        <small>Código de referência: {this.state.reference}</small>
      </main>
    );
  }
}
